import { POSITION_SLOT_LIFECYCLE } from './constants';
import type { PositionSlot } from './types';

const hasAssignedWorker = (positionSlot: PositionSlot) =>
  Boolean(positionSlot.employeeAlias || positionSlot.employeeAliases?.length);

const hasLinkedPositionFillRequest = (positionSlot: PositionSlot) => Boolean(positionSlot.positionFulfillmentRequestId);

const isPositionSlotEngaged = (positionSlot: PositionSlot) =>
  hasAssignedWorker(positionSlot) || hasLinkedPositionFillRequest(positionSlot);

export const canEditPositionSlot = (positionSlot: PositionSlot) =>
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.ACTIVE ||
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.FROZEN;

export const canAssignPositionSlot = (positionSlot: PositionSlot) =>
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.ACTIVE ||
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.FROZEN;

export const canFreezePositionSlot = (positionSlot: PositionSlot) =>
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.ACTIVE && !isPositionSlotEngaged(positionSlot);

export const canUnfreezePositionSlot = (positionSlot: PositionSlot) =>
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.FROZEN;

export const canRetirePositionSlot = (positionSlot: PositionSlot) =>
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.ACTIVE ||
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.FROZEN;

export const canCreatePositionFillRequest = (positionSlot: PositionSlot) =>
  positionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.ACTIVE &&
  !hasLinkedPositionFillRequest(positionSlot) &&
  (!hasAssignedWorker(positionSlot) || positionSlot.requiredReplacement);
